import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { FiBell } from "react-icons/fi";
import { useSelector } from "react-redux";
import { RootState } from "../../State/store";
import CampaignIcon from '@mui/icons-material/Campaign';
import { useNtfy } from "../ui/ntfy";
// import Notification from "@/src/Pages/Settings/Notification";

interface Notification {
  unread: boolean;
  id: number;
  campaignId: number;
  workspaceId: number;
  campaignName: string;
  statusMark: string;
  notificationType: string;
  createdAt: string;
  notificationData: {
    ChannelName?: string;
    CampaignName?: string;
    [key: string]: string | undefined;
  };
  role: string;
}

const NotificationBellAdmin: React.FC = () => {
  const [notifications, setNotifications] = useState<Notification[]>([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [showNotifications, setShowNotifications] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [isNtfyConnected, setIsNtfyConnected] = useState(false);
  const [hasInitialLoad, setHasInitialLoad] = useState(false);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const notificationRef = useRef<HTMLDivElement>(null);

  const apiUrlAdvAcc = useSelector((state: RootState) => state.authentication.apiURL);

  // Initial load effect - loads existing notifications on login
  useEffect(() => {
    if (!apiUrlAdvAcc || hasInitialLoad) return;

    const loadInitialNotifications = async () => {
      try {
        const [countResponse, notificationsResponse] = await Promise.all([
          axios.get(`${apiUrlAdvAcc}/GetNotificationsCountForAdmin`),
          axios.get(`${apiUrlAdvAcc}/GetNotificationsForAdmin`)
        ]);

        if (countResponse.data.status === "Success") {
          setUnreadCount(countResponse.data.notificationCount);
        }

        if (notificationsResponse.data.status === "Success") {
          const notifications: Notification[] = notificationsResponse.data.notifications.map((n: any) => ({
            id: n.id,
            campaignId: n.campaignId,
            workspaceId: n.workspaceId,
            campaignName: n.campaignName || "",
            unread: n.statusMark === "Unread",
            statusMark: n.statusMark,
            notificationType: n.notificationType,
            createdAt: n.createdAt,
            notificationData: n.notificationData || {},
            role: n.role
          }));
          setNotifications(notifications);
        }

        setHasInitialLoad(true);
      } catch (error) {
        console.error("Error loading initial admin notifications:", error);
      }
    };

    loadInitialNotifications();
  }, [apiUrlAdvAcc, hasInitialLoad]);

  // API polling effect - only runs as fallback when ntfy is disconnected
  useEffect(() => {
    if (!apiUrlAdvAcc || isNtfyConnected || !hasInitialLoad) return;

    console.log("Starting admin API polling fallback - ntfy disconnected");

    const fetchLiveNotificationsCount = async () => {
      try {
        const response = await axios.get(`${apiUrlAdvAcc}/GetNotificationsCountForAdmin`);
        if (response.data.status === "Success") {
          setUnreadCount(response.data.notificationCount);
        }
      } catch (error) {
        console.error("Error fetching admin notifications count:", error);
      }
    };

    // Start polling immediately when ntfy disconnects
    fetchLiveNotificationsCount();
    // const interval = setInterval(fetchLiveNotificationsCount,80000); // Continue polling every 80 seconds

    return () => {
      console.log("Stopping admin API polling - ntfy reconnected or component unmounted");
      // clearInterval(interval);
    };
  }, [apiUrlAdvAcc, isNtfyConnected, hasInitialLoad]);

  const fetchLiveNotifications = async () => {

    // If ntfy is connected, don't fetch from API
    if (isNtfyConnected) return;
    debugger;

    try {
      const response = await axios.get(`${apiUrlAdvAcc}/GetNotificationsForAdmin`);
      console.log("🔹 Full API Response:", response.data);

      const notifications: Notification[] = response.data.notifications.map((n: any) => ({
        id: n.id,
        campaignId: n.campaignId,
        workspaceId: n.workspaceId,
        campaignName: n.campaignName || "",
        unread: n.statusMark === "Unread",
        statusMark: n.statusMark,
        notificationType: n.notificationType,
        createdAt: n.createdAt,
        notificationData: n.notificationData || {},
        role: n.role
      }));

      const unreadNotifications = notifications.filter((n) => n.unread);
      setNotifications(notifications);
      setUnreadCount(unreadNotifications.length);
    } catch (error) {
      console.error("Error fetching admin notifications:", error);
    }
  };
  //  const fetchLiveNotifications = async () => {
  //   if (isNtfyConnected) return;

  //   try {
  //     const response = await axios.get(
  //       `${apiUrlAdvAcc}/GetNotificationsForAdmin`
  //     );
  //     if (response.data.status === "Success") {
  //       const mapped: Notification[] = response.data.notifications.map(
  //         (n: any) => ({
  //           id: n.id,
  //           campaignId: n.campaignId,
  //           workspaceId: n.workspaceId,
  //           campaignName: n.campaignName || "",
  //           unread: n.statusMark === "Unread",
  //           statusMark: n.statusMark,
  //           notificationType: n.notificationType,
  //           createdAt: n.createdAt,
  //           notificationData: safeParse(n.notificationData),
  //           role: n.role,
  //         })
  //       );
  //       setNotifications(mapped);
  //       setUnreadCount(mapped.filter((n) => n.unread).length);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching admin notifications:", error);
  //   }
  // };

  // ntfy connection with connection status tracking
  useNtfy("Admin", (evt) => {
    // Set connection status when we receive any event
    setIsNtfyConnected(true);
    debugger;

    const type = String(evt?.type || "").toLowerCase();

    if (type === "notification_created" || (!evt.type && evt.id)) {
      const unread =
        (evt.statusMark ?? evt.statusmark ?? "Unread").toLowerCase() === "unread";
      if (unread) setUnreadCount((c) => c + 1);
      debugger;

 try {
  const rawmsgdata = evt.message;

  // Check if the evt.message is a stringified JSON and parse it if so
  const msgdata = typeof rawmsgdata === "string" ? JSON.parse(rawmsgdata) : rawmsgdata;
  
 const notificationId = msgdata.id;
  console.log("Notification ID:", notificationId);

  // Get the raw notification data from msgdata
  const rawnotificationdata = msgdata.notificationdata;

  // Ensure `notificationdata` is parsed if it's a string
  const notificationdata = typeof rawnotificationdata === "string" 
    ? JSON.parse(rawnotificationdata) // If it's a string, parse it
    : rawnotificationdata;  // If it's already an object, leave it as is

  // Access the parsed notification data and store in a variable
  const notifymessage = notificationdata.Message;
  debugger;

  console.log("Parsed Notification Data:", notificationdata);
  console.log("Message:", notifymessage);
  
  // Proceed with handling the notification data (e.g., update state, etc.)
  setNotifications((prev) => [
    {
      id: notificationId,
      campaignId: msgdata.campaignId ?? msgdata.campaignid ?? 0,
      workspaceId: msgdata.workspaceId ?? msgdata.workspaceid ?? 0,
      campaignName: msgdata.campaignName ?? msgdata.campaignname ?? notificationdata.CampaignName ?? "",
      unread: (msgdata.statusMark ?? msgdata.statusmark ?? "Unread").toLowerCase() === "unread",
      statusMark: msgdata.statusMark ?? msgdata.statusmark ?? "Unread",
      notificationType: msgdata.notificationType ?? msgdata.notificationtype ?? "",
      createdAt: msgdata.createdAt ?? msgdata.createdat ?? new Date().toISOString(),
      notificationData: notificationdata,
      role: "Admin", // Assuming this is always "Admin" for this context
    },
    ...prev,  // Keep previous notifications in the state
  ]);
} catch (error) {
  console.error("Error processing the notification data:", error);
}
    }

    if (type === "notification_read" || type === "notification_bulk_read") {
      const ids: number[] = evt.ids ?? (evt.id ? [evt.id] : []);
      if (ids.length) {
        setNotifications((prev) =>
          prev.map((n) =>
            ids.includes(n.id) ? { ...n, unread: false, statusMark: "Read" } : n
          )
        );
        setUnreadCount((c) => Math.max(0, c - ids.length));
      }
    }
  });

const markAllAsRead = async () => {
  try {
    debugger;
    const unreadAdminNotifications = notifications
      .filter((n) => n.unread && n.role?.toLowerCase() === "admin")
      .map((n) => n.id);  // numeric only

    if (unreadAdminNotifications.length === 0) return;

    await Promise.all(
      unreadAdminNotifications.map((id) =>
        axios.post(`${apiUrlAdvAcc}/MarkAdminNotificationsRead?id=${id}`)
      )
    );
    debugger;
    // After marking notifications as read, update the UI state
    setNotifications((prev) =>
      prev.map((n) =>
        
        unreadAdminNotifications.includes(n.id) ? { ...n, unread: false } : n
      )
    );
    setUnreadCount(0);  // Reset unread count
    setShowNotifications(false);  // Close the notification bell
    setNotifications([]);  // Optionally clear the notifications (or you can update the state to show read notifications)

  } catch (error) {
    console.error("Error marking admin notifications as read:", error);
  }
};



  const handleBellClick = async () => {
    // Only fetch from API if ntfy is not connected
    if (!isNtfyConnected) {
      await fetchLiveNotifications();
    }
    
    const nextState = !showNotifications;
    setShowNotifications(nextState);

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    if (nextState) {
      timeoutRef.current = setTimeout(() => {
        setShowNotifications(false);
      }, 80000);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (notificationRef.current && !notificationRef.current.contains(event.target as Node)) {
        setShowNotifications(false);
      }
    };

    if (showNotifications) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showNotifications]);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return (
    <div className="relative" ref={notificationRef}>
      <div onClick={handleBellClick} className="cursor-pointer">
        <FiBell style={{ width: "16px", height: "16px", color: "#0F172A" }} />
        {unreadCount > 0 && (
          <span className="absolute -top-2 -right-2 bg-red-500 text-white text-[10px] font-bold px-1 rounded-full min-w-[12px] h-[12px] flex items-center justify-center leading-none">
            {unreadCount}
          </span>
        )}
      </div>

      {showNotifications && (
        <div className="z-30 mr-6 absolute mt-4 right-0 transform translate-x-12 w-64 min-w-[280px] bg-white border border-gray-300 rounded shadow-lg p-3 overflow-visible">
          {notifications.length === 0 ? (
            <p className="text-gray-500 text-xs text-center">You have no unread notifications</p>
          ) : (
            <ul className={`${expanded ? "max-h-48" : "max-h-[96px]"} overflow-y-auto pr-1 divide-y divide-gray-200`}>
              {notifications
                .slice(0, expanded ? undefined : 2)
                .map((notification) => {
                  const messageValues = Object.values(notification.notificationData || {});
                  const message = messageValues.length > 0 ? messageValues[0] : "You have a new notification.";

                  return (
                    <li
                      key={notification.id}
                      className={`flex items-start text-xs py-2 text-left ${notification.unread ? "font-semibold text-slate-900" : "text-slate-700"
                        }`}
                    >
                      <CampaignIcon fontSize="small" className="text-blue-500 mr-2 mt-[2px]" />
                      <span className="leading-snug">{message}</span>
                    </li>
                  );
                })}
            </ul>
          )}

          {notifications.length > 2 && (
            <div className="border-t border-gray-200 pt-2 text-center mt-2">
              <button
                className="text-xs text-blue-600 hover:underline"
                onClick={() => setExpanded((prev) => !prev)}
              >
                {expanded ? "Show Less" : "Show All"}
              </button>
            </div>
          )}

          {(notifications.length <= 2 || expanded) &&
            notifications.filter((n) => n.unread).length > 0 && (
              <>
                <hr className="my-2" />
                <button
                  className="w-full bg-blue-500 text-white py-1 rounded text-xs hover:bg-blue-600 transition"
                  onClick={markAllAsRead}
                >
                  Mark all as read
                </button>
              </>
            )}
        </div>
      )}
    </div>
  );
};

export default NotificationBellAdmin;